import { MdTextAction } from '../types'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { useNavigate, useSearchParams } from 'react-router'
import { CATALOG_BASE_PATH } from '@/const'
import { useCatalogComponentRuntime } from '../../shared/CatalogComponentRuntimeContext'

export function ActionItemNoConfirmation({
  action,
  markdown,
  reloadHandler,
}: {
  action: MdTextAction
  markdown: string
  reloadHandler: () => void
}) {
  const handlerId = action.handlerId || ''
  const actionId = action.id || ''
  const emptyTileFilterSelections: Record<string, unknown>[] = []
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { allowRouteNavigation = true } = useCatalogComponentRuntime()
  const { mutate: submitForm } = useSubmitForm(handlerId, emptyTileFilterSelections, actionId)

  const onSelect = (_e: Event) => {
    if (action.type === 'navigate' && !allowRouteNavigation) {
      return
    }
    if (action.type === 'navigate') {
      navigate(`${CATALOG_BASE_PATH}${handlerId}?${searchParams.toString()}`)
      return
    }
    if (action.type === 'reload') {
      reloadHandler()
      return
    }
    submitForm({ data: markdown })
  }

  const isDisabled = action.type === 'navigate' && !allowRouteNavigation

  return (
    <DropdownMenuItem key={action.id} onSelect={onSelect} disabled={isDisabled}>
      <div className="flex items-center gap-2">
        <DynamicIcon
          iconName={action.icon || ''}
          lazyLoad={false}
          className="size-3"
          fallback={<div className="size-4" />}
        />
        <span>{action.label}</span>
      </div>
    </DropdownMenuItem>
  )
}
